import {Component, EventEmitter, Input, OnInit, Output} from '@angular/core';
import {
  EventItem, ListSortOrder,
  Lookups,
  PagedFilter, Pages,
  RaceRegistration, RegistrationFilter,
  StatementImportItem,
  TypeOfRegistration
} from "@model";
import {NgbModal, NgbModalRef} from "@ng-bootstrap/ng-bootstrap";
import {RegistrationDetailsModalComponent} from "@components";
import {TranslocoService} from "@ngneat/transloco";
import {RaceService} from "@services";
import {Observable} from 'rxjs';
import {PagingComponent} from "../../../../../../components/paging.component";

@Component({
    selector: 'app-event-management-registrations-list',
    templateUrl: './event-management-registrations-list.component.html',
    styleUrl: './event-management-registrations-list.component.scss',
    standalone: false
})
export class EventManagementRegistrationsListComponent extends PagingComponent<RaceRegistration> implements OnInit {
  @Input({required: true}) languages: Lookups[] = [];
  @Input({required: true}) eventItem?: EventItem;
  @Input({required: true}) raceRegistrations: RaceRegistration[] = [];
  @Input({required: true}) disableRegisterToRace: boolean = false;
  @Output() registerToRace: EventEmitter<void> = new EventEmitter<void>();
  @Output() getFileFromServer: EventEmitter<string> = new EventEmitter<string>();


  constructor(private modalService: NgbModal,
              private translocoService: TranslocoService,
              private raceService: RaceService) {
    super()
  }

  override ngOnInit(): void {
    super.ngOnInit();
    this.handleExploreResult(this.raceRegistrations);
  }

  onRegisterToRace() {
    this.registerToRace.next();
  }

  onGetFileFromServer(type:string) {
    this.getFileFromServer.next(type);
  }

  registrationDetails(raceRegistration: RaceRegistration) {
    const modalRef: NgbModalRef = this.modalService.open(RegistrationDetailsModalComponent, {
      centered: true,
      windowClass: 'registration-details-modal',
    });
    modalRef.componentInstance.title = this.translocoService.translate("account.statements.registration.details");
    modalRef.componentInstance.raceRegistration = raceRegistration;
    modalRef.componentInstance.languages = this.languages;

    modalRef.result.then((_:StatementImportItem) => {
    }, (_) => {
      /// ignore
    });
  }

  protected fetchPage(page: number): Observable<RaceRegistration[]> {
    let pagedFilter: PagedFilter<RegistrationFilter> = new PagedFilter(new Pages(undefined, this.page),
        new RegistrationFilter(undefined, undefined, this.eventItem?.id, undefined),
        ListSortOrder.DESC);
    return this.raceService.findMatchingRegistrations(pagedFilter);
  }

  protected override afterSetItems(items: RaceRegistration[]): void {
    this.raceRegistrations = items;
  }

  protected readonly TypeOfRegistration = TypeOfRegistration;
  protected readonly RaceRegistration = RaceRegistration;
}
